'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import LoadingSpinner from '@/src/app/components/LoadingSpinner/LoadingSpinner';
import './AddToCart.scss';
import { Dictionary } from '@/src/lib/dictionary/types';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
export type AddToCartProps = {
  dict: Dictionary;
  withLabel?: boolean;
  disabled?: boolean;
  className?: string;
  onButtonClick: () => void;
  error?: boolean;
  success?: boolean;
  isAddToCartPending?: boolean;
};
function AddToCartButton(t0) {
  const $ = _c(35);
  const {
    dict,
    withLabel,
    disabled,
    error,
    success,
    isAddToCartPending,
    className,
    onButtonClick
  } = t0;
  const t1 = !withLabel;
  let t2;
  if ($[0] !== className || $[1] !== error || $[2] !== success || $[3] !== t1 || $[4] !== withLabel) {
    t2 = classNames(className, "button priority group flex justify-center items-center transition-colors px-5 py-[13px] h-full", {
      "bg-danger!": error,
      "bg-success!": success,
      "w-[3.125rem]": t1,
      "text-white uppercase px-5 font-semibold": withLabel
    });
    $[0] = className;
    $[1] = error;
    $[2] = success;
    $[3] = t1;
    $[4] = withLabel;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isAddToCartPending || disabled;
  let t4;
  if ($[6] !== isAddToCartPending) {
    t4 = isAddToCartPending ? <LoadingSpinner small={true} /> : null;
    $[6] = isAddToCartPending;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isAddToCartPending || $[9] !== success) {
    t5 = !isAddToCartPending && success ? <Icon name={IconName.CHECK} className="text-primary check-mark" /> : null;
    $[8] = isAddToCartPending;
    $[9] = success;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== error || $[12] !== isAddToCartPending) {
    t6 = !isAddToCartPending && error ? <Icon name={IconName.ERROR} className="text-primary" /> : null;
    $[11] = error;
    $[12] = isAddToCartPending;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== disabled || $[15] !== error || $[16] !== isAddToCartPending || $[17] !== success) {
    t7 = !isAddToCartPending && !success && !error ? <Icon name={IconName.ADD_SHOPPING_CART} className={classNames("icon", {
      "group-active:scale-75 transition-all": !disabled
    })} /> : null;
    $[14] = disabled;
    $[15] = error;
    $[16] = isAddToCartPending;
    $[17] = success;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <span className="w-6 h-6">{t4}{t5}{t6}{t7}</span>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const t9 = !withLabel;
  let t10;
  if ($[24] !== t9) {
    t10 = classNames("ml-4", {
      "sr-only": t9
    });
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== dict.general.addToCart || $[27] !== t10) {
    t11 = <span className={t10}>{dict.general.addToCart}</span>;
    $[26] = dict.general.addToCart;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== onButtonClick || $[30] !== t11 || $[31] !== t2 || $[32] !== t3 || $[33] !== t8) {
    t12 = <button className={t2} type="button" onClick={onButtonClick} data-testid="add-to-cart-button" disabled={t3}>{t8}{t11}</button>;
    $[29] = onButtonClick;
    $[30] = t11;
    $[31] = t2;
    $[32] = t3;
    $[33] = t8;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}
export default AddToCartButton;